export const templates = [
    {
        name: "@system/mobile/pages/authentication/identity-profile-list",
        loader: () => import("./IdentityProfileList"),
        pure: true,
    },
    {
        name: "@system/mobile/pages/authentication/identity-profile-detail",
        loader: () => import("./IdentityProfileDetail"),
        pure: true,
    },
    {
        name: "@system/mobile/pages/authentication/authenticators/demo",
        loader: () => import("./IdentityProfileDetail/DemoAuthenticator"),
        pure: true,
    },
];